
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/penilaian-kinerja/demo/langkah-penetapan-predikat-kinerja/panduan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/penilaian-kinerja/demo/langkah-penetapan-predikat-kinerja/panduan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/penilaian-kinerja/demo/langkah-penetapan-predikat-kinerja/panduan"])
      });
    }
  